import { render, staticRenderFns } from "./terminateDialog.vue?vue&type=template&id=15815da9&scoped=true"
import script from "./terminateDialog.vue?vue&type=script&lang=js"
export * from "./terminateDialog.vue?vue&type=script&lang=js"
import style0 from "./terminateDialog.vue?vue&type=style&index=0&id=15815da9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15815da9",
  null
  
)

export default component.exports